import {
    FETCH_PENDING_VISITS, FETCH_PENDING_VISITS_ERROR, FETCH_PENDING_VISITS_START, FETCH_PENDING_VISITS_SUCCESS, SET_PENDING_VISITORS_PAGINATION
} from "../../actions/receptionist/pendingVisitorsAction";
import _ from 'lodash';
const INIT_STATE = {
    error: "",
    loading: false,
    submitting: false,
    message: '',
    pendingVisitors: [],
    pagination: {
        currentPage: 1,
        pageSize: 20,
        totalPages: 0,
        totalItems: 0,
    },
};

const pendingVisitor = (state = INIT_STATE, action) => {
    let newState;
    let newPendingVisitors;
    let index;
    switch (action.type) {
        // case FETCH_PENDING_VISITS: {
        //     return { ...state };
        // }
        case FETCH_PENDING_VISITS_START: {
            return { ...state, error: '', message: '', loading: true, pendingVisitors: [] };
        }
        case FETCH_PENDING_VISITS_SUCCESS: {
            newState = { ...state }
            newState.pendingVisitors = [...action.pendingVisitors];
            return { ...newState, loading: false }
        }

        case FETCH_PENDING_VISITS_ERROR: {
            return { ...state, loading: false }
        }

        case SET_PENDING_VISITORS_PAGINATION: {
            return { ...state, error: '', message: '', pagination: { ...action.pagination } };
        }

        default: return state;
    }
}
export default pendingVisitor;